import reducer from './reducers/index';
import {setUserId} from './actions/actions';

export default class UserResponseHandler
{
	constructor(settings)
    {
        this._settings = settings;
	}

    initialize(store)
    {
        this._dispatch = store.dispatch;
    }

    getReducer()
    {
        return reducer;
    }

    process(message)
    {
        //Bailout if not handles
        if(!this.doesHandle(message)) return message;

        let response = Array.isArray(message.response) ? 
                       message.response[0] :
                       message.response;
        let userId = response !== undefined ? response.userId : null;


        if(userId)
        {
            this._dispatch(setUserId(
		        userId, this._settings.stateLocations.Conversation.userId
	        ));
        }

        return message;
    }

    doesHandle(message)
    {
        let handles = false;
        if(message.response)
        {
            let response = Array.isArray(message.response) ? 
                           message.response[0] :
                           message.response;
            handles = response !== undefined && response.userId !== undefined;
        }
        return handles;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/user/src/response-handler-user.js